import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURFeatureModel from "../models/BURFeatureModel";

export class BURHasBlueRespinCondition implements ICondition {
    public check(): boolean {
        return (
            BURFeatureModel.will_base_game_feature_trigger &&
            BURFeatureModel.blue_respin_data !== undefined
        );
    }
}
